import { Navigate, Outlet, useLocation, useMatches } from 'react-router';

import { ClientCommunicationDrawerProvider } from '@/components/comments/ClientCommunicationDrawer/ClientCommunicationDrawerContext';
import { GlobalToastRegion } from '@/design_system/Toast';
import { useCurrentSession } from '@/services/auth';
import { useHeap } from '@/services/heap';
import { ErrorBoundary } from '@/services/sentry';
import { createBEMClasses } from '@/utils/classname';
import useViewPort from '@/utils/useViewport';

import Navbar from './Navbar/Navbar';
import SettingsNavbar from './SettingsNavbar/SettingsNavbar';

import './App.css';

const { block } = createBEMClasses('app');

const App = () => {
  const { isMobile } = useViewPort();
  const { currentSession } = useCurrentSession();

  const matchingRoutes = useMatches();
  const fullPage = matchingRoutes.some(({ handle }) => (handle as any)?.displayOnFullPage);
  const hideNavBar = isMobile && fullPage;

  const { pathname } = useLocation();
  const isSettingsShell = !!currentSession?.isSupport && pathname.startsWith('/settings_beta');

  useHeap();

  if (currentSession?.roles.length === 0) {
    return <Navigate to="/no-organizations" />;
  }

  return (
    <ClientCommunicationDrawerProvider>
      {isSettingsShell ? !isMobile && <SettingsNavbar /> : !hideNavBar && <Navbar />}
      <main
        className={block({
          'full-page': fullPage,
        })}
      >
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
      <GlobalToastRegion />
    </ClientCommunicationDrawerProvider>
  );
};

export default App;
